import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';
import PayrocOnlinePayment from 'components/Payments/payroc/PayrocOnlinePayment';
import Checkbox from 'components/shared/Checkbox/Checkbox';

const NewCard = ({ onError, hideButton = false }) => {
  const { handlePayment, setFieldValue } = usePaymentContextApi();
  const { values, terminalPin } = usePaymentContext();

  return (
    <PayrocOnlinePayment
      key="pay-with-new-card"
      id="pay-with-new-card"
      amount={values.amount}
      handlePayment={handlePayment}
      onError={onError}
      hideButton={hideButton}
      terminalPin={terminalPin}
      className="self-end">
      <div className="flex flex-col gap-3 self-start">
        <Checkbox
          size={16}
          isChecked={values.saveCard}
          onChange={(event) => setFieldValue('saveCard', event.target.checked)}
          className="max-w-[456px]"
          innerLabelClassName="items-start"
          labelClassName="text-xs leading-[14px] font-medium"
          label="Save this card for future payments."
        />
      </div>
    </PayrocOnlinePayment>
  );
};

export default NewCard;
